import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronUp, Filter, RotateCcw } from "feather-icons-react";
// import Table from "../../../core/pagination/datatable";
import { Table } from "antd";
import { useEffect } from "react";
import { OverlayTrigger } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { setheadertoggle } from "../../../redux/toggle";
import {
  exportExcel,
  exportPDF,
  HandlePrint,
  renderTooltip,
} from "../../../redux/helper";
import {
  fetchUnit,
  fetchProduct,
  fetchTax,
  fetchSettings,
  fetchCustomer,
} from "../../../redux/userSetting";
import { DatePicker, Select, Tabs } from "antd";
import { getConsolidatedReportSectionwise } from "../../../services/ReportApiService";
import {
  consolidatedBranches,
  fetchConsolidatedInvoices,
  invoicePaySummaryRow,
} from "./consolidatedInvoices";
import {
  DatatablePagingParameter,
  Filterclass,
} from "../../../core/json/DatatablePagingParameters";
import dayjs from "dayjs";
import { useMemo } from "react";
import LoadingUtils from "../../../core/utils/LoadingUtils";
import {
  exportMasterExcel,
  exportMasterPDF,
  printMasterReport,
} from "../../../core/utils/ReportFooterUtils";
import { Calendar } from "feather-icons-react/build/IconComponents";
 
const ItemsReport = () => {
  const [searchText, setSearchText] = useState("");
  const [reportData, setreportData] = useState([]);
  const [loading, setloading] = useState(false);
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const { branch } = useSelector((state) => state.branchlist);
  const { BranchByUser } = useSelector((state) => state.userBranch);
  const dispatch = useDispatch();
  const [decimalpoints, setDecimalPoints] = useState(2);
    const {
     
      settingList,
   
    } = useSelector((state) => state.usersetting);
  const { TabPane } = Tabs;
  const [activeTab, setActiveTab] = useState("1");
  const { togglehead } = useSelector((state) => state.headerToggle);
  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };
  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };
 
  const handleFromDateChange = (date) => {
    setFromDate(date);
 
    // keep the to-date valid: pull it up to the new from-date only if it falls before it
    setToDate((prev) =>
      date && prev && !dayjs(prev).isBefore(date, "day") ? prev : date
    );
  };
  const handleToDateChange = (date) => {
    setToDate(date);
  };
  // reload when the period is complete again, as the other consolidated reports do
  useEffect(() => {
    handleReportList();
  }, [branch, fromDate, toDate]);
  useEffect(() => {
      dispatch(fetchUnit());
        dispatch(fetchProduct(branch));
        dispatch(fetchTax());
        dispatch(fetchSettings(branch));
   
        const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
        const currfmt = match ? match[0]?.length - 1 : 0;
        setDecimalPoints(currfmt);
  }, []);
  const handleReportList = async () => {
    // wait for two valid dates instead of sending "Invalid Date"
    // (the API answers that with a 500)
    if (
      !fromDate ||
      !toDate ||
      !dayjs(fromDate).isValid() ||
      !dayjs(toDate).isValid()
    )
      return;
    setloading(true);
    const DatatablePagingParameters = new DatatablePagingParameter();
    const formattedfromDate = dayjs(fromDate)
      .startOf("day")
      .format("YYYY-MM-DD");
    const formattedtoDate = dayjs(toDate).endOf("day").format("YYYY-MM-DD");
    // const formattedfromDate = "2024-08-04";
    // const formattedtoDate = "2024-08-05";
    DatatablePagingParameters.PageSize = -1;
    const Filters = new Filterclass();
    Filters.Branch = branch;
    Filters.FromDate = formattedfromDate;
    Filters.ToDate = formattedtoDate;
    Filters.PaymentType = "";
    Filters.Waiter = "";
    Filters.Counter = "";
   // Filters.Section = "";
    try {
      // POS sales (consolidated endpoint) + sales invoices / returns of every
      // branch; one failing source does not blank the other
      const [consol, invoices] = await Promise.allSettled([
        getConsolidatedReportSectionwise({ DatatablePagingParameters, Filters }),
        consolidatedBranches(BranchByUser).then((list) =>
          fetchConsolidatedInvoices(list, formattedfromDate, formattedtoDate)
        ),
      ]);
      setloading(false);
      if (consol.status === "rejected")
        console.error(consol.reason?.response?.data?.Message || "Consolidated sales failed");
      if (invoices.status === "rejected")
        console.error(invoices.reason?.response?.data?.Message || "Sales invoices failed");
      const invoiceRows = (invoices.status === "fulfilled" ? invoices.value : []).map((r) =>
        invoicePaySummaryRow(r)
      );
      // Branch Total (-)Complementary  (-)Canceled (-)Refund Gross (-)Discount NetTotal  Cash  Card  Credit
      const salesReportConsol =
        (consol.status === "fulfilled" && consol.value?.data?.salesReportConsol) || [];
//console.log("salesReport console",salesReportConsol)
      if (Array.isArray(salesReportConsol)) {
       // console.log("object",salesReportConsol)
        const dataArray = salesReportConsol?.map((item) => {
           const refund = item.refund ? item.netTotal : 0.0;
           const cancelled = item.cancelled ? item.netTotal : 0.0;
           const discount = item.discount;
           const complementary =  item.paymentType == 5 ? item.netTotal : 0.0;
           const extra = item.extra ? item.extra: 0.0;
           const gross=item.rateTotal + extra - discount;
          return{
          branch: item.branch?.name,
          trnDate: dayjs(item?.transactionDate).format("DD MMM YYYY"),
          complementary: item.paymentType == 5 ? item.netTotal : 0.0,
          cancelled: item.cancelled ? item.netTotal : 0.0,
          refund: item.refund ? item.netTotal : 0.0,
          gross: item.rateTotal+extra-discount,
          discount: item.discount,
          netTotal: gross-cancelled-complementary-refund,
          total:item.rateTotal,
          cash: item.cash-refund < 0 ? 0: item.cash-refund,
          card: item.card-refund < 0 ? 0: item.card-refund,
          credit: item.paymentType == 4 ? item.netTotal-refund < 0? 0:item.netTotal-refund  : 0.0,
          extra:item.extra? item.extra : 0.0,
          }
        })
//console.log("dataarray",dataArray);
        setreportData([...dataArray, ...invoiceRows]);
      } else {
        console.error("Data is not in the expected array format");
        setreportData(invoiceRows);
      }
    } catch (error) {
      setloading(false);
      console.error(error?.response?.data?.Message || "Something went wrong");
      setreportData([]);
    }
  };
 
  const { branches, detailData,summerizedData } = useMemo(() => {
    const safeReportData = Array.isArray(reportData) ? reportData : [];
 
    const branches = [...new Set(safeReportData?.map((item) => item.branch))];
    const trnDates = [...new Set(safeReportData?.map((item) => item.trnDate))];
 
//     const detailData =
//       branches?.map((branch) => {
//         const row = { key: branch, branch };
// console.log("safe",safeReportData,branches)
//         safeReportData?.map((item) => {
//           if (item.branch === branch) {
     
//             row["complementary"] = item.complementary || 0;
//             row["cancelled"] = item.cancelled || 0;
//             row["refund"] = item.refund || 0;
//             row["gross"] = item.gross || 0;
//             row["discount"] = item.discount || 0;
//             row["netTotal"] = item.netTotal || 0;
//             row["cash"] = item.cash || 0;
//             row["card"] = item.card || 0;
//             row["credit"] = item.credit || 0;
//           }
//         });
 
//         return row;
//       }) || [];
// console.log("detail",detailData)
 
 
 
 
 
 
 
 
 
 
 
const branchTotals = {};
 
safeReportData?.forEach((item) => {
    const branch = item.branch;
 
    if (!branchTotals[branch]) {
        // Initialize the branch record if not exists
        branchTotals[branch] = {
            key: branch,
            branch,
            complementary: 0,
            cancelled: 0,
            refund: 0,
            gross: 0,
            discount: 0,
            netTotal: 0,
            cash: 0,
            card: 0,
            credit: 0,
            total:0,
            extra:0,
       
        };
    }
 
    // Sum values for each branch
    branchTotals[branch].complementary += item.complementary || 0;
    branchTotals[branch].cancelled += item.cancelled || 0;
    branchTotals[branch].refund += item.refund || 0;
    branchTotals[branch].gross += item.gross || 0;
    branchTotals[branch].discount += item.discount || 0;
    branchTotals[branch].netTotal += item.netTotal || 0;
    branchTotals[branch].cash += item.cash || 0;
    branchTotals[branch].card += item.card || 0;
    branchTotals[branch].credit += item.credit || 0;
    branchTotals[branch].total += item.total || 0;
    branchTotals[branch].extra += item.extra || 0;
});
const dataBranchTotals = {};
 
safeReportData.forEach((item) => {
  const key = `${item.trnDate}-${item.branch}`;
 
  if (!dataBranchTotals[key]) {
      dataBranchTotals[key] = {
          trnDate: item.trnDate,
          branch: item.branch,
          total: 0,
          extra: 0,
          discount: 0,
          gross: 0,
          complementary: 0,
          cancelled: 0,
          refund: 0,
          netTotal: 0,
          cash: 0,
          card: 0,
          credit: 0,
      };
  }
 
  // Sum values for each (Date + Branch)
  dataBranchTotals[key].total += item.total || 0;
  dataBranchTotals[key].extra += item.extra || 0;
  dataBranchTotals[key].discount += item.discount || 0;
  dataBranchTotals[key].gross += item.gross || 0;
  dataBranchTotals[key].complementary += item.complementary || 0;
  dataBranchTotals[key].cancelled += item.cancelled || 0;
  dataBranchTotals[key].refund += item.refund || 0;
  dataBranchTotals[key].netTotal += item.netTotal || 0;
  dataBranchTotals[key].cash += item.cash || 0;
  dataBranchTotals[key].card += item.card || 0;
  dataBranchTotals[key].credit += item.credit || 0;
});
 
// Convert dictionary to array
 
 
 
 
return {
    branches: Object.keys(branchTotals),  // Extracting unique branches
   detailData: Object.values(branchTotals),
 summerizedData:Object.values(dataBranchTotals),
};
 
 
  }, [reportData]);
  const handleTabChange = (key) => {
    setActiveTab(key);
  };
  const detailColumns1 = [
    {
      title: "Branch",
      dataIndex: "branch",
      key: "branch",
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
       align: "right",
      render: (value) => (value !== undefined ? value.toFixed(decimalpoints) : 0),
    },
    {
      title: "Extra Charges",
      dataIndex: "extra",
      key: "extra",
       align: "right",
      render: (value) => (value !== undefined ? value.toFixed(decimalpoints) : 0),
    },
    {
      title: "Discount",
      dataIndex: "discount",
      key: "discount",
       align: "right",
      render: (value) => (value !== undefined ? value?.toFixed(decimalpoints) : 0),
    },
    {
      title: "Gross",
      dataIndex: "gross",
      key: "gross",
       align: "right",
      render: (value) => (value !== undefined ? value?.toFixed(decimalpoints) : 0),
    },
    {
      title: "Complementary",
      dataIndex: "complementary",
      key: "complementary",
       align: "right",
      render: (value) => (value !== undefined ? value.toFixed(decimalpoints) : 0),
    },
    {
      title: "Cancelled",
      dataIndex: "cancelled",
      key: "cancelled",
       align: "right",
      render: (value) => (value !== undefined ? value?.toFixed(decimalpoints) : 0),
    },
    {
      title: "Refund",
      dataIndex: "refund",
      key: "refund",
       align: "right",
      render: (value) => (value !== undefined ? value?.toFixed(decimalpoints) : 0),
    },
    {
      title: "NetTotal",
      dataIndex: "netTotal",
      key: "netTotal",
       align: "right",
      render: (value) => (value !== undefined ? value?.toFixed(decimalpoints) : 0),
    },
    {
      title: "Cash",
      dataIndex: "cash",
      key: "cash",
       align: "right",
      render: (value) => (value !== undefined ? value?.toFixed(decimalpoints) : 0),
    },
    {
      title: "Card",
      dataIndex: "card",
      key: "card",
       align: "right",
      render: (value) => (value !== undefined ? value?.toFixed(decimalpoints) : 0),
    },
 
    {
      title: "Credit",
      dataIndex: "credit",
      key: "credit",
       align: "right",
      render: (value) => (value !== undefined ? value?.toFixed(decimalpoints) : 0),
    },
   
  ];
 
  const detailColumns = [
    {
      title: "Date",
      dataIndex: "trnDate",
      key: "trnDate",
    },
    {
      title: "Branch",
      dataIndex: "branch",
      key: "branch",
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
       align: "right",
      render: (value) => (value !== undefined ? value?.toFixed(decimalpoints) : 0),
    },
    {
      title: "Extra Charges",
      dataIndex: "extra",
      key: "extra",
       align: "right",
      render: (value) => (value !== undefined ? value.toFixed(decimalpoints) : 0),
    },
    {
      title: "Discount",
      dataIndex: "discount",
      key: "discount",
       align: "right",
      render: (value) => (value !== undefined ? value?.toFixed(decimalpoints) : 0),
    },
    {
      title: "Gross",
      dataIndex: "gross",
      key: "gross",
       align: "right",
      render: (value) => (value !== undefined ? value?.toFixed(decimalpoints) : 0),
    },
    {
      title: "Complementary",
      dataIndex: "complementary",
      key: "complementary",
       align: "right",
      render: (value) => (value !== undefined ? value?.toFixed(decimalpoints) : 0),
    },
    {
      title: "Cancelled",
      dataIndex: "cancelled",
      key: "cancelled",
       align: "right",
      render: (value) => (value !== undefined ? value?.toFixed(decimalpoints) : 0),
    },
    {
      title: "Refund",
      dataIndex: "refund",
      key: "refund",
       align: "right",
      render: (value) => (value !== undefined ? value?.toFixed(decimalpoints) : 0),
    },
    {
      title: "NetTotal",
      dataIndex: "netTotal",
      key: "netTotal",
       align: "right",
      render: (value) => (value !== undefined ? value?.toFixed(decimalpoints) : 0),
    },
    {
      title: "Cash",
      dataIndex: "cash",
      key: "cash",
       align: "right",
      render: (value) => (value !== undefined ? value?.toFixed(decimalpoints) : 0),
    },
    {
      title: "Card",
      dataIndex: "card",
      key: "card",
       align: "right",
      render: (value) => (value !== undefined ? value?.toFixed(decimalpoints) : 0),
    },
 
    {
      title: "Credit",
      dataIndex: "credit",
      key: "credit",
       align: "right",
      render: (value) => (value !== undefined ? value?.toFixed(decimalpoints) : 0),
    },
   
  ];
   const grandtotal = reportData?.reduce(
     (sum, record) => sum + record.total,
     0
   );
  const grandcomplementary = reportData?.reduce(
    (sum, record) => sum + record.complementary,
    0
  );
  const grandcancelled = reportData?.reduce(
    (sum, record) => sum + record.cancelled,
    0
  );
  const grandrefund = reportData?.reduce(
    (sum, record) => sum + record.refund,
    0
  );
  const grandextraCharge = reportData?.reduce(
    (sum, record) => sum + record.extra,
    0
  );
  const grandgross = reportData?.reduce((sum, record) => sum + record.gross, 0);
  const granddiscount = reportData?.reduce(
    (sum, record) => sum + record.discount,
    0
  );
  const grandnetTotal = reportData?.reduce(
    (sum, record) => sum + record.netTotal,
    0
  );
  const grandcash = reportData?.reduce((sum, record) => sum + record.cash, 0);
  const grandcard = reportData?.reduce((sum, record) => sum + record.card, 0);
  const grandcredit = reportData?.reduce(
    (sum, record) => sum + record.credit,
    0
  );
 
  const footerTotals = {
    total:grandtotal?.toFixed(decimalpoints) || 0,
    extra:grandextraCharge?.toFixed(decimalpoints) || 0,
    netTotal: grandnetTotal?.toFixed(decimalpoints) || 0,
    complementary: grandcomplementary?.toFixed(decimalpoints) || 0,
    cancelled: grandcancelled?.toFixed(decimalpoints) || 0,
    refund: grandrefund?.toFixed(decimalpoints) || 0,
    gross: grandgross?.toFixed(decimalpoints) || 0,
    discount: granddiscount?.toFixed(decimalpoints) || 0,
    cash: grandcash?.toFixed(decimalpoints) || 0,
    card: grandcard?.toFixed(decimalpoints) || 0,
    credit: grandcredit?.toFixed(decimalpoints) || 0,
  };
 
  //console.log("footerTotals", footerTotals);
 
  function handleReset() {
    // restore valid defaults; the date change re-runs the fetch effect
    setFromDate(dayjs());
    setToDate(dayjs());
    setSearchText("");
    setreportData([]);
    // setModifiedList([]);
    //detailData = [];
  }
  const getActiveTabData = () => {
    let fieldMapping = {};
 
    const createfieldMapping = (columns) => {
      const mappings = {};
      columns.forEach((col) => {
        mappings[col.title] = col.dataIndex; // Map column title to its dataIndex
      });
      return mappings;
    };
    switch (activeTab) {
      case "1":
        fieldMapping = createfieldMapping(detailColumns);
       // console.log("fieldMapping of first table:", fieldMapping);
        return { data: reportData, columns: detailColumns, fieldMapping };
      case "2":
        fieldMapping = createfieldMapping(detailColumns1);
       // console.log("fieldMapping of second table:", fieldMapping);
        return { data: detailData, columns: detailColumns1, fieldMapping };
      default:
        return { data: [], columns: [] };
    }
  };
  return (
    <div className="ax-master ax-report">
      <LoadingUtils loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Consolidated Paymode Reports</h4>
                <h6>Manage paymode reports here</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                  <Link
                    onClick={() =>
                      exportMasterPDF(
                        getActiveTabData,
                        footerTotals,
                        "Paymode wise Report"
                      )
                    }
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Excel")}
                >
                  <Link
                    onClick={() =>
                      exportMasterExcel(
                        getActiveTabData,
                        footerTotals,
                        "Paymode wise Report"
                      )
                    }
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Print")}
                >
                  <Link
                    onClick={() =>
                      printMasterReport(
                        getActiveTabData,
                        footerTotals,
                        "Paymode wise Report"
                      )
                    }
                  >
                    <i data-feather="printer" className="feather-printer" />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Refresh")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    onClick={() => handleReportList()}
                  >
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Collapse")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={togglehead ? "active" : ""}
                    onClick={handletogglehead}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
 
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top ">
                <div className="search-set">
                  <div className="search-input">
                    <Link to="#" className="btn btn-searchset">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-search"
                      >
                        <circle cx={11} cy={11} r={8} />
                        <line x1={21} y1={21} x2="16.65" y2="16.65" />
                      </svg>
                    </Link>
                    <div
                      id="DataTables_Table_0_filter"
                      className="dataTables_filter"
                    >
                      <label>
                        {" "}
                        <input
                          type="search"
                          className="form-control form-control-sm"
                          placeholder="Search"
                          aria-controls="DataTables_Table_0"
                          value={searchText}
                          onChange={handleSearch}
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="input-blocks">
                        <label>From Date</label>
                        {/* <Calendar className="info-img" /> */}
                        <DatePicker
                          className="datetimepicker"
                          id="from-date"
                          placeholderText="From Date"
                          selected={fromDate}
                          value={fromDate}
                          onChange={handleFromDateChange}
                          startDate={fromDate}
                          selectsStart
                          dateFormat="dd/MM/yyyy"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="input-blocks">
                        <label>To Date</label>
                        {/* <Calendar className="info-img" /> */}
                        <DatePicker
                          id="to-date"
                          placeholderText="To Date"
                          value={toDate}
                          onChange={handleToDateChange}
                          minDate={fromDate}
                          startDate={fromDate}
                          selectsEnd
                          disabled={!fromDate}
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="input-blocks p-3 mt-3">
                    <Link
                      className="btn btn-filters rounded-2 "
                      onClick={handleReportList}
                    >
                      <i data-feather="search" className="feather-search" />{" "}
                      Search{" "}
                    </Link>
                  </div>
                  <div className="input-blocks mt-3">
                    <button
                      className="btn btn-reset  rounded-2 "
                      onClick={handleReset}
                    >
                      <i
                        data-feather="refresh-cw"
                        className="feather-refresh-cw"
                      />{" "}
                      Reset
                    </button>
                  </div>
                </div>
              </div>
 
              <div className="table-responsive">
                <Tabs defaultActiveKey="1" onChange={handleTabChange}>
                  <TabPane tab="Detailed View" key="1">
                    <Table
                      className="table datanew dataTable no-footer custom-table"
                      columns={detailColumns}
                      dataSource= {summerizedData}
                      summary={() => (
                        <Table.Summary.Row>
                          {detailColumns?.map((col) => (
                            <Table.Summary.Cell key={col.dataIndex}>
                               <div style={{ textAlign: "right" }}>
                              <b>{footerTotals[col.dataIndex] || ""}</b>
                              </div>
                            </Table.Summary.Cell>
                          ))}
                        </Table.Summary.Row>
                      )}
                    />
                  </TabPane>
                  <TabPane tab="Summary View" key="2">
                    <Table
                      className="table datanew dataTable no-footer custom-table"
                      columns={detailColumns1}
                      dataSource={detailData}
                      summary={() => (
                        <Table.Summary.Row>
                          {detailColumns1?.map((col) => (
                            <Table.Summary.Cell key={col.dataIndex}>
                               <div style={{ textAlign: "right" }}>
                              <b>{footerTotals[col.dataIndex] || ""}</b>
                              </div>
                            </Table.Summary.Cell>
                          ))}
                        </Table.Summary.Row>
                      )}
                    />
                  </TabPane>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ItemsReport;
 
 